import { NestedFilter } from "./generic";

export function evaluateNestedFilter<T>(item: T, filter: NestedFilter<T>): boolean {
  if ('field' in filter) {
    const fieldValue = item[filter.field];
    const value = filter.value;

    switch (filter.operator) {
      case '==': return fieldValue === value;
      case '!=': return fieldValue !== value;
      case '<': return fieldValue < value;
      case '<=': return fieldValue <= value;
      case '>': return fieldValue > value;
      case '>=': return fieldValue >= value;
      case 'array-contains':
        return Array.isArray(fieldValue) && fieldValue.includes(value);
      case 'in':
        return Array.isArray(value) && value.includes(fieldValue);
      case 'not-in':
        return Array.isArray(value) && !value.includes(fieldValue);
      case 'array-contains-any':
        return (
          Array.isArray(fieldValue) &&
          Array.isArray(value) &&
          value.some((v) => fieldValue.includes(v))
        );
      default:
        console.warn(`Unsupported operator: ${filter.operator}`);
        return false;
    }
  }

  if ('and' in filter) {
    return filter.and.every((sub) => evaluateNestedFilter(item, sub));
  }

  if ('or' in filter) {
    return filter.or.some((sub) => evaluateNestedFilter(item, sub));
  }

  return true;
}
